const initialState = () => ({
  codecs: [],
});

const state = initialState();

export default state;
